import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'markdown-inline',
  templateUrl: './markdown-inline.component.html',
  styleUrls: ['./markdown-inline.component.scss']
})
export class MarkdownInlineComponent implements OnInit {

  @Input() input:string;
  output:string;

  constructor() { }

  ngOnInit() {
    let val = this.input;

    const regex_bold = /\*\*[A-z0-9 ]+\*\*/gi;
    const regex_em = /\*[A-z0-9 ]+\*/gi;
    const regex_del = /\~\~[A-z0-9 ]+\~\~/gi;
    const stripMarkedupEdges = (count, str) => {
      return str.substr(count, str.length-count*2)
    }
    
    val = val.replace(regex_bold, (str) => '<strong>' + stripMarkedupEdges(2, str) + '</strong>');
    val = val.replace(regex_em, (str) => '<em>' + stripMarkedupEdges(1, str) + '</em>');
    val = val.replace(regex_del, (str) => '<del>' + stripMarkedupEdges(2, str) + '</del>');

    this.output = val;
  }

}
